/**
 * Achievement percentage color mapping (shared across Team and My Data views).
 * Target is assumed constant (out of scope).
 *
 * < 33% - Red
 * >= 33% and < 80% - Orange
 * >= 80% and < 100% - Yellow
 * >= 100% - Green
 */
export type TAchievementColorClass = 'red' | 'orange' | 'yellow' | 'green' | 'gray'

export function getAchievementColorClass(percent: number): TAchievementColorClass {
    if (!isFinite(percent) || percent < 0) return 'gray'

    if (percent < 33) return 'red'
    if (percent < 80) return 'orange'
    if (percent < 100) return 'yellow'
    return 'green'
}
